import { usePointageEmployeeOptions, resolvePointageEmployeeFromSelect, resolvePointageEmployeeDisplayName } from '../pointage/pointageListPageUtils';
import localApiAdapter from '../../core/services/localApiAdapter';
import { parseChainSteps, normalizeChainStep } from './approbationsShared';

/** Live HR employee options for approbations requester / chain step pickers. */
export function useApprobationsEmployeeOptions(options = {}) {
  return usePointageEmployeeOptions(localApiAdapter.get.bind(localApiAdapter), options);
}

export function buildApprobationsEmployeeSelectOptions(employeeOptions, { emptyLabel = '' } = {}) {
  const opts = (employeeOptions || []).map((o) => ({
    value: String(o.meta?.id ?? o.value),
    label: o.label,
    meta: o.meta,
  }));
  return emptyLabel ? [{ value: '', label: emptyLabel }, ...opts] : opts;
}

export function resolveApprobationsEmployeeFromSelect(value, employeeOptions = []) {
  return resolvePointageEmployeeFromSelect(value, employeeOptions);
}

export function resolveApprobationsEmployeeDisplayName(employeeId, employeeOptions = [], fallback = '') {
  return resolvePointageEmployeeDisplayName(employeeId, employeeOptions, fallback);
}

/** Refresh employee_name on chain steps when HR data changes. */
export function enrichChainStepsWithEmployees(steps = [], employeeOptions = []) {
  return parseChainSteps(steps).map((step, i) => {
    const base = normalizeChainStep(step, i + 1);
    if (!base.employee_id) return base;
    const name = resolveApprobationsEmployeeDisplayName(
      base.employee_id,
      employeeOptions,
      base.employee_name,
    );
    return { ...base, employee_name: name || base.employee_name };
  });
}
